<template>
  <Layout background-color="#e3e9ea" active="fin-models" hide-logout="true" title="Financial Models">
    <div v-if="!loading ">
      <div v-if="userTemplates.length > 0">
        <h2 align="center">
          Purchased Templates
        </h2>
        <div class="sep-24"></div>
        <div class="columns">
          <div class="column is-4" v-for="userTemplate in userTemplates">
            <div class="template-block">
              <div class="template-block-image"></div>
              <div class="template-block-content">
                <div class="template-block-title">{{ userTemplate.template.name }}</div>
                <div class="template-block-tags tags">
              <span class="tag" v-for="tag in getTemplateTags(userTemplate.template)">
                {{ tag }}
              </span>
                </div>
                <div class="template-block-description">
                  {{ userTemplate.template.description }}
                </div>
                <hr>
                <div class="template-block-footer">
                  <!-- <div class="template-block-footer-price">
                     ${{userTemplate.template.price}}
                   </div>-->
                  <!--              <div class="template-block-footer-likes">
                                <span class="icon">
                                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                       width="100" height="100"
                                       viewBox="0,0,256,256">
                                    <g fill="#ff0f0f" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                                       stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                                       font-family="none" font-weight="none" font-size="none" text-anchor="none"
                                       style="mix-blend-mode: normal"><g transform="scale(5.12,5.12)"><path
                                        d="M16.375,9c-6.25781,0 -11.375,5.05469 -11.375,11.28125c0,12.76953 14.48828,19.45703 19.375,23.5l0.625,0.53125l0.625,-0.53125c4.88672,-4.04297 19.375,-10.73047 19.375,-23.5c0,-6.22656 -5.11719,-11.28125 -11.375,-11.28125c-3.47656,0 -6.53906,1.61328 -8.625,4.0625c-2.08594,-2.44922 -5.14844,-4.0625 -8.625,-4.0625zM16.375,11c3.26563,0 6.10547,1.65234 7.78125,4.15625l0.84375,1.25l0.84375,-1.25c1.67578,-2.50391 4.51563,-4.15625 7.78125,-4.15625c5.18359,0 9.375,4.14453 9.375,9.28125c0,10.89844 -12.26172,17.00781 -18,21.5c-5.73828,-4.49219 -18,-10.60156 -18,-21.5c0,-5.13672 4.1875,-9.28125 9.375,-9.28125z"></path></g></g>
                                  </svg>
                                </span>
                                  0
                                </div>
                                <div class="template-block-footer-views">
                                <span class="icon">
                                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                       viewBox="0,0,256,256">
                                    <g fill="#aea5a5" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                                       stroke-linejoin="miter"
                                       stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none"
                                       font-weight="none"
                                       font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.12,5.12)"><path
                                        d="M25,2.00781c-12.6907,0 -23,10.3093 -23,23c0,12.69071 10.3093,23 23,23c12.69071,0 23,-10.30929 23,-23c0,-12.6907 -10.3093,-23 -23,-23zM25,4.00781c11.60982,0 21,9.39018 21,21c0,5.7327 -2.296,10.91804 -6.01172,14.70508c-1.82978,-1.34332 -4.06023,-2.01731 -5.94922,-2.68945c-1.06387,-0.37855 -2.02041,-0.75368 -2.71875,-1.17188c-0.66881,-0.40051 -1.04022,-0.8121 -1.23633,-1.28516c-0.09185,-1.14686 -0.07325,-2.07015 -0.06641,-3.16016c0.12115,-0.12066 0.27658,-0.20543 0.40039,-0.35156c0.29199,-0.34463 0.58928,-0.76341 0.87305,-1.23438c0.48659,-0.8076 0.84066,-1.7954 1.03906,-2.79687c0.30297,-0.15444 0.62662,-0.18786 0.87305,-0.50195c0.45497,-0.57991 0.76211,-1.396 0.89844,-2.5332c0.12089,-1.00405 -0.2026,-1.69462 -0.61914,-2.22461c0.44811,-1.46482 1.0029,-3.79433 0.81445,-6.20508c-0.10367,-1.32631 -0.43741,-2.66133 -1.24023,-3.77148c-0.76647,-1.05988 -2.01085,-1.82174 -3.60352,-2.09766c-1.01156,-1.14848 -2.61842,-1.68945 -4.53906,-1.68945h-0.00977h-0.00781c-4.30274,0.07899 -7.07893,1.85984 -8.26758,4.57617c-1.13029,2.58298 -0.8873,5.7986 -0.07617,9.14648c-0.43603,0.53002 -0.77759,1.23377 -0.6543,2.26563c0.13684,1.13682 0.4438,1.95325 0.89844,2.5332c0.24624,0.31412 0.56993,0.34743 0.87305,0.50195c0.19837,1.0007 0.55251,1.98715 1.03906,2.79492c0.28376,0.47111 0.58075,0.88946 0.87305,1.23438c0.12384,0.14614 0.2791,0.23279 0.40039,0.35352c0.0065,1.08943 0.02497,2.01236 -0.06641,3.16016c-0.19572,0.47132 -0.56665,0.88312 -1.23437,1.28516c-0.69723,0.4198 -1.65263,0.79702 -2.71484,1.17773c-1.88699,0.67633 -4.11619,1.35516 -5.95117,2.6875c-3.718,-3.78737 -6.01562,-8.9743 -6.01562,-14.70898c0,-11.60982 9.39018,-21 21,-21zM24.92188,10.00195c1.84413,0.0019 3.0044,0.54791 3.32227,1.10547l0.24414,0.42773l0.48633,0.06641c1.25618,0.17455 1.95805,0.66202 2.46094,1.35742c0.50289,0.69541 0.78199,1.66591 0.86719,2.75586c0.1704,2.1799 -0.4536,4.75406 -0.84961,5.94531l-0.25195,0.75586l0.68164,0.41406c-0.06934,-0.04222 0.32048,0.18853 0.23242,0.91992c-0.10667,0.8898 -0.33405,1.34302 -0.48633,1.53711c-0.15228,0.19409 -0.21746,0.1693 -0.20117,0.16797l-0.82422,0.06836l-0.08789,0.82227c-0.07543,0.70647 -0.47277,1.67009 -0.9375,2.44141c-0.23236,0.38566 -0.47958,0.72921 -0.6875,0.97461c-0.20792,0.2454 -0.42934,0.3974 -0.3457,0.35352l-0.53516,0.2793v0.60547c0,1.32432 -0.05395,2.40729 0.08594,3.94922l0.01172,0.13281l0.04688,0.125c0.39353,1.05904 1.21498,1.80623 2.13867,2.35938c0.92369,0.55315 1.98342,0.95297 3.07617,1.3418c1.80096,0.64082 3.67832,1.27145 5.10938,2.20313c-3.64629,3.05412 -8.34295,4.89648 -13.47852,4.89648c-5.13358,0 -9.82892,-1.84058 -13.47461,-4.89258c1.43918,-0.92632 3.31934,-1.55874 5.11719,-2.20312c1.09203,-0.3914 2.14898,-0.79293 3.07031,-1.34766c0.92133,-0.55473 1.73984,-1.30179 2.13281,-2.35742l0.04688,-0.125l0.01172,-0.13281c0.13875,-1.54074 0.08594,-2.62391 0.08594,-3.94922v-0.60547l-0.53516,-0.28125c0.08375,0.04381 -0.13772,-0.10808 -0.3457,-0.35352c-0.20799,-0.24543 -0.45514,-0.58689 -0.6875,-0.97266c-0.46472,-0.77154 -0.8621,-1.73593 -0.9375,-2.44141l-0.08789,-0.82227l-0.82422,-0.06836c0.01545,0.0013 -0.04906,0.02608 -0.20117,-0.16797c-0.15211,-0.19405 -0.37917,-0.64693 -0.48633,-1.53711c-0.08741,-0.73154 0.30679,-0.96511 0.23242,-0.91992l0.63477,-0.38477l-0.18555,-0.7207c-0.86045,-3.31171 -0.99057,-6.32499 -0.10547,-8.34766c0.88423,-2.02067 2.65548,-3.30266 6.46094,-3.375z"></path></g></g>
                                  </svg>
                                </span>
                                  <span class="icon">
                                  <strong>94</strong>
                                </span>
                                </div>-->
                </div>
                <div class="template-block-footer-button">
                  <a :href="userTemplate.template.sheet_url" target="_blank" class="button is-primary">Download</a>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <hr v-if="userTemplates.length>0"/>
      <div class="purchased-templates" v-if="otherTemplates.length>0">
        <div v-if="false">
          <h2 align="center">
            All Templates
          </h2>
          <div class="sep-24"></div>
          <div class="columns is-centered">
            <div class="is-6">
              <button class="button is-primary is-medium">Unlock all Templates for $300</button>
            </div>
          </div>
        </div>
        <div class="sep-24"></div>
        <div class="columns">
          <div class="column is-4" v-for="template in otherTemplates">
            <div class="template-block">
              <div class="template-block-image"></div>
              <div class="template-block-content">
                <div class="template-block-title">{{ template.name }}</div>
                <div class="template-block-tags tags">
                <span class="tag" v-for="tag in getTemplateTags(template)">
                  SaaS
                </span>
                </div>
                <div class="template-block-description">
                  {{ template.description }}
                </div>
                <hr>
                <div class="template-block-footer">
                  <div class="template-block-footer-price">
                    ${{ template.price }}
                    <!--                  <span class="icon">USD</span>-->
                  </div>
                  <!--                <div class="template-block-footer-likes">
                                <span class="icon">
                                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                       width="100" height="100"
                                       viewBox="0,0,256,256">
                                    <g fill="#ff0f0f" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                                       stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                                       font-family="none" font-weight="none" font-size="none" text-anchor="none"
                                       style="mix-blend-mode: normal"><g transform="scale(5.12,5.12)"><path
                                        d="M16.375,9c-6.25781,0 -11.375,5.05469 -11.375,11.28125c0,12.76953 14.48828,19.45703 19.375,23.5l0.625,0.53125l0.625,-0.53125c4.88672,-4.04297 19.375,-10.73047 19.375,-23.5c0,-6.22656 -5.11719,-11.28125 -11.375,-11.28125c-3.47656,0 -6.53906,1.61328 -8.625,4.0625c-2.08594,-2.44922 -5.14844,-4.0625 -8.625,-4.0625zM16.375,11c3.26563,0 6.10547,1.65234 7.78125,4.15625l0.84375,1.25l0.84375,-1.25c1.67578,-2.50391 4.51563,-4.15625 7.78125,-4.15625c5.18359,0 9.375,4.14453 9.375,9.28125c0,10.89844 -12.26172,17.00781 -18,21.5c-5.73828,-4.49219 -18,-10.60156 -18,-21.5c0,-5.13672 4.1875,-9.28125 9.375,-9.28125z"></path></g></g>
                                  </svg>
                                </span>
                                    0
                                  </div>
                                  <div class="template-block-footer-views">
                                <span class="icon">
                                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                       viewBox="0,0,256,256">
                                    <g fill="#aea5a5" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                                       stroke-linejoin="miter"
                                       stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none"
                                       font-weight="none"
                                       font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.12,5.12)"><path
                                        d="M25,2.00781c-12.6907,0 -23,10.3093 -23,23c0,12.69071 10.3093,23 23,23c12.69071,0 23,-10.30929 23,-23c0,-12.6907 -10.3093,-23 -23,-23zM25,4.00781c11.60982,0 21,9.39018 21,21c0,5.7327 -2.296,10.91804 -6.01172,14.70508c-1.82978,-1.34332 -4.06023,-2.01731 -5.94922,-2.68945c-1.06387,-0.37855 -2.02041,-0.75368 -2.71875,-1.17188c-0.66881,-0.40051 -1.04022,-0.8121 -1.23633,-1.28516c-0.09185,-1.14686 -0.07325,-2.07015 -0.06641,-3.16016c0.12115,-0.12066 0.27658,-0.20543 0.40039,-0.35156c0.29199,-0.34463 0.58928,-0.76341 0.87305,-1.23438c0.48659,-0.8076 0.84066,-1.7954 1.03906,-2.79687c0.30297,-0.15444 0.62662,-0.18786 0.87305,-0.50195c0.45497,-0.57991 0.76211,-1.396 0.89844,-2.5332c0.12089,-1.00405 -0.2026,-1.69462 -0.61914,-2.22461c0.44811,-1.46482 1.0029,-3.79433 0.81445,-6.20508c-0.10367,-1.32631 -0.43741,-2.66133 -1.24023,-3.77148c-0.76647,-1.05988 -2.01085,-1.82174 -3.60352,-2.09766c-1.01156,-1.14848 -2.61842,-1.68945 -4.53906,-1.68945h-0.00977h-0.00781c-4.30274,0.07899 -7.07893,1.85984 -8.26758,4.57617c-1.13029,2.58298 -0.8873,5.7986 -0.07617,9.14648c-0.43603,0.53002 -0.77759,1.23377 -0.6543,2.26563c0.13684,1.13682 0.4438,1.95325 0.89844,2.5332c0.24624,0.31412 0.56993,0.34743 0.87305,0.50195c0.19837,1.0007 0.55251,1.98715 1.03906,2.79492c0.28376,0.47111 0.58075,0.88946 0.87305,1.23438c0.12384,0.14614 0.2791,0.23279 0.40039,0.35352c0.0065,1.08943 0.02497,2.01236 -0.06641,3.16016c-0.19572,0.47132 -0.56665,0.88312 -1.23437,1.28516c-0.69723,0.4198 -1.65263,0.79702 -2.71484,1.17773c-1.88699,0.67633 -4.11619,1.35516 -5.95117,2.6875c-3.718,-3.78737 -6.01562,-8.9743 -6.01562,-14.70898c0,-11.60982 9.39018,-21 21,-21zM24.92188,10.00195c1.84413,0.0019 3.0044,0.54791 3.32227,1.10547l0.24414,0.42773l0.48633,0.06641c1.25618,0.17455 1.95805,0.66202 2.46094,1.35742c0.50289,0.69541 0.78199,1.66591 0.86719,2.75586c0.1704,2.1799 -0.4536,4.75406 -0.84961,5.94531l-0.25195,0.75586l0.68164,0.41406c-0.06934,-0.04222 0.32048,0.18853 0.23242,0.91992c-0.10667,0.8898 -0.33405,1.34302 -0.48633,1.53711c-0.15228,0.19409 -0.21746,0.1693 -0.20117,0.16797l-0.82422,0.06836l-0.08789,0.82227c-0.07543,0.70647 -0.47277,1.67009 -0.9375,2.44141c-0.23236,0.38566 -0.47958,0.72921 -0.6875,0.97461c-0.20792,0.2454 -0.42934,0.3974 -0.3457,0.35352l-0.53516,0.2793v0.60547c0,1.32432 -0.05395,2.40729 0.08594,3.94922l0.01172,0.13281l0.04688,0.125c0.39353,1.05904 1.21498,1.80623 2.13867,2.35938c0.92369,0.55315 1.98342,0.95297 3.07617,1.3418c1.80096,0.64082 3.67832,1.27145 5.10938,2.20313c-3.64629,3.05412 -8.34295,4.89648 -13.47852,4.89648c-5.13358,0 -9.82892,-1.84058 -13.47461,-4.89258c1.43918,-0.92632 3.31934,-1.55874 5.11719,-2.20312c1.09203,-0.3914 2.14898,-0.79293 3.07031,-1.34766c0.92133,-0.55473 1.73984,-1.30179 2.13281,-2.35742l0.04688,-0.125l0.01172,-0.13281c0.13875,-1.54074 0.08594,-2.62391 0.08594,-3.94922v-0.60547l-0.53516,-0.28125c0.08375,0.04381 -0.13772,-0.10808 -0.3457,-0.35352c-0.20799,-0.24543 -0.45514,-0.58689 -0.6875,-0.97266c-0.46472,-0.77154 -0.8621,-1.73593 -0.9375,-2.44141l-0.08789,-0.82227l-0.82422,-0.06836c0.01545,0.0013 -0.04906,0.02608 -0.20117,-0.16797c-0.15211,-0.19405 -0.37917,-0.64693 -0.48633,-1.53711c-0.08741,-0.73154 0.30679,-0.96511 0.23242,-0.91992l0.63477,-0.38477l-0.18555,-0.7207c-0.86045,-3.31171 -0.99057,-6.32499 -0.10547,-8.34766c0.88423,-2.02067 2.65548,-3.30266 6.46094,-3.375z"></path></g></g>
                                  </svg>
                                </span>
                                    <span class="icon">
                                  <strong>94</strong>
                                </span>
                                  </div>-->
                </div>
                <div class="template-block-footer-button">
                  <button class="button is-primary" @click="showDetailsModel(template)">Get Started</button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/shared/components/Layout";
import {FinModelsAPI} from "@/apis/FinModelsAPI";
import ShareModal from "@/modules/calculator/modals/ShareModal";
import FinModelDetails from "@/modules/fin-models/modals/FinModelDetails";

export default {
  components: {
    Layout,
  },
  data() {
    return {
      userTemplates: [],
      otherTemplates: [],
      loading: true,
    };
  },
  name: "fin-models",
  async mounted() {
    const userTemplatesPromise = FinModelsAPI.getUserTemplates().then((response) => {
      this.userTemplates = response;
    });

    const otherTemplatesPromise = FinModelsAPI.getOtherTemplates().then((response) => {
      this.otherTemplates = response;
    });

    await Promise.all([userTemplatesPromise, otherTemplatesPromise]);
    this.loading = false;
  },
  methods: {
    getTemplateTags(template) {
      return template.tags.split(",").map(tag => tag.trim());
    },
    showDetailsModel(template){
      this.$buefy.modal.open({
        parent: this,
        component: FinModelDetails,
        customClass: "med-modal",
        props: {
          template: template
        },
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.template-block {
  overflow: hidden;
  background-color: #fff;
  border-radius: 4px;
  width: 100%;
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02);

  .template-block-content {
    padding: 10px;
  }

  .template-block-image {
    width: 100%;
    height: 200px;
    background-color: #fff;
    margin-bottom: 5px;
    background-image: url(../../../images/landing-page/methodology_header.jpg);
  }

  .template-block-title {
    font-size: 20px;
    margin-bottom: 5px;
  }

  .template-block-tags {
    margin-bottom: 5px;
  }

  .template-block-footer {
    display: flex;
    justify-content: center;
    margin-bottom: 5px;

    & > div {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 10px;

      .icon {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 5px 5px 5px 5px;
        color: #999;
      }
    }
  }

  .template-block-footer-button {
    text-align: center;
    width: 100%;
  }

  .template-block-description {
    ul {
      padding: 0;
      margin: 0 0 0 15px;
    }
  }

  .template-block-footer-price {
    font-size: 24px;
  }

  hr {
    height: 1px;
    width: 100px;
    margin: 15px auto;
    background-color: #ccc;
  }
}
</style>